import { useEffect, useState } from "react";

export function useParamsState(key, defaultValue, type = "string") {
  // Read initial value from URL
  const getInitialValue = () => {
    const params = new URLSearchParams(window.location.search);
    const raw = params.get(key);
    if (raw == null) return defaultValue;
    if (type === "number") return parseInt(raw, 10);
    return raw;
  };

  const [value, setValue] = useState(getInitialValue);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    if (value === defaultValue) {
      params.delete(key);
    } else {
      params.set(key, value);
    }

    const newUrl = `${window.location.pathname}?${params.toString()}`;
    // Update URL without reloading the page
    window.history.pushState({}, "", newUrl);
  }, [value, key, defaultValue]);

  return [value, setValue];
}